<div mat-dialog-content>
  <div class="col-12">
    @for (opt of options; track opt) {
      <button disabled="available" class="col-6" style="float: left;" (click)="optionSelected(opt)">
        <mat-card appearance="outlined">
          {{opt.title}}
        </mat-card>
      </button>
    }
  </div>
  <br>
    <hr>
    </div>
    <div mat-dialog-actions>
      <div class="col-12">
        <div id="myData"></div>
        <!-- {{data}} -->
      </div>